(() => {
 const boot = () => {
  const root = document.querySelector('#floptropica-community');
  if (!root || root.dataset.directoryReady) return;
  root.dataset.directoryReady = 'true';
  const grid = root.querySelector('#fc-member-grid');
  const status = root.querySelector('#fc-member-status');
  const count = root.querySelector('#fc-member-count');
  const search = root.querySelector('#fc-member-search');
  const more = root.querySelector('#fc-member-more');
  const dialog = root.querySelector('#fc-member-dialog');
  const badgeUrl = 'https://api.floptropica.com/v1/news-assets/news/brand/verified.png';
  const citizenBadgeUrl = 'https://api.floptropica.com/v1/news-assets/news/brand/citizen-flag-borderless.png';
  const founderBadgeUrl = 'https://api.floptropica.com/v1/news-assets/news/brand/founder-badge.png';
  const linkedMember = new URL(location.href).searchParams.get('member');
  if (linkedMember && /^[a-z0-9._]{3,20}$/.test(linkedMember)) search.value = linkedMember;
  let cursor = null;
  let requestId = 0;
  let controller;
  let timer;

  function avatar(member) {
    const element = document.createElement('span');
    element.className = 'fc-community__avatar';
    if (member.avatarUrl) {
      const image = document.createElement('img');
      image.src = member.avatarUrl;
      image.alt = '';
      image.loading = 'lazy';
      element.append(image);
    } else {
      element.textContent = member.username.slice(0, 1).toUpperCase();
    }
    return element;
  }

  function name(member) {
    const element = document.createElement('span');
    element.className = 'fc-community__name';
    const text = document.createElement('span');
    text.textContent = `@${member.username}`;
    element.append(text);
    if (member.verified) {
      const badge = document.createElement('img');
      badge.className = 'fc-community__badge';
      badge.src = badgeUrl;
      badge.alt = 'Verified';
      element.append(badge);
    }
    for (const [active, label, source, kind] of [
      [member.founder, 'Founder', founderBadgeUrl, 'founder'],
      [member.citizen, 'Citizen', citizenBadgeUrl, 'citizen'],
    ]) {
      if (!active) continue;
      const badge = document.createElement('img');
      badge.className = `fc-community__badge fc-community__badge--${kind}`;
      badge.src = source;
      badge.alt = label;
      badge.title = label;
      element.append(badge);
    }
    return element;
  }

  function memberships(member) {
    const row = document.createElement('span');
    row.className = 'fc-community__memberships';
    for (const [visible, label, url] of [
      [member.citizen, 'Citizen', citizenBadgeUrl],
      [member.founder, 'Founder', founderBadgeUrl],
    ]) {
      if (!visible) continue;
      const badge = document.createElement('span');
      badge.className = 'fc-community__membership';
      const image = document.createElement('img');
      image.src = url;
      image.alt = '';
      image.loading = 'lazy';
      badge.append(image, document.createTextNode(label));
      row.append(badge);
    }
    return row;
  }

  function memberDetails(member) {
    const details = document.createElement('span');
    details.className = 'fc-community__details';
    if (member.city) {
      const city = document.createElement('span');
      city.textContent = member.city;
      details.append(city);
    }
    if (member.memberSince) {
      const date = new Date(member.memberSince);
      if (!Number.isNaN(date.getTime())) {
        const joined = document.createElement('span');
        joined.textContent = `Member since ${new Intl.DateTimeFormat(undefined, {day: 'numeric', month: 'short', year: 'numeric'}).format(date)}`;
        details.append(joined);
      }
    }
    return details;
  }

  function socials(member) {
    const row = document.createElement('span');
    row.className = 'fc-community__socials';
    for (const [url, label] of [[member.instagramUrl, 'Instagram'], [member.tiktokUrl, 'TikTok']]) {
      if (!url) continue;
      const link = document.createElement('a');
      link.href = url;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      link.textContent = `${label} ↗`;
      link.setAttribute('aria-label', `${member.username} on ${label} (opens in a new tab)`);
      row.append(link);
    }
    return row;
  }

  function openMember(member) {
    const content = dialog.querySelector('.fc-community__dialog-content');
    content.replaceChildren();
    const kicker = document.createElement('span');
    kicker.className = 'fc-community__dialog-kicker';
    kicker.textContent = 'Floptropica member';
    content.append(avatar(member), name(member), memberships(member), memberDetails(member), socials(member), kicker);
    dialog.showModal();
    const url = new URL(location.href);
    url.searchParams.set('member', member.username);
    history.replaceState(null, '', url);
  }

  function card(member) {
    const element = document.createElement('article');
    element.className = 'fc-community__card';
    const main = document.createElement('button');
    main.type = 'button';
    main.className = 'fc-community__card-main';
    main.setAttribute('aria-label', `View ${member.username}'s public profile`);
    main.append(avatar(member), name(member), memberships(member), memberDetails(member));
    main.addEventListener('click', () => openMember(member));
    element.append(main, socials(member));
    return element;
  }

  async function load(reset = false) {
    if (reset) {
      controller?.abort();
      grid.replaceChildren();
      cursor = null;
    }
    const id = ++requestId;
    controller = new AbortController();
    status.textContent = 'Loading the community…';
    more.hidden = true;
    const url = new URL('https://api.floptropica.com/v1/community/members');
    const query = search.value.trim().toLowerCase();
    if (query) url.searchParams.set('q', query);
    if (cursor) url.searchParams.set('after', cursor);
    try {
      const response = await fetch(url, {signal: controller.signal});
      const data = await response.json();
      if (!response.ok || !data.ok) throw new Error(data.error || 'Could not load members.');
      if (id !== requestId) return;
      count.textContent = new Intl.NumberFormat().format(data.total);
      data.members.forEach((member) => grid.append(card(member)));
      cursor = data.nextCursor;
      more.hidden = !cursor;
      status.textContent = grid.children.length ? '' : 'No members found. Try another username.';
      const memberFromUrl = new URL(location.href).searchParams.get('member');
      if (memberFromUrl && !dialog.open) {
        const match = data.members.find((member) => member.username === memberFromUrl);
        if (match) openMember(match);
      }
    } catch (error) {
      if (error.name === 'AbortError' || id !== requestId) return;
      status.textContent = 'The community is unavailable right now. Please try again.';
      more.hidden = false;
      more.textContent = 'Try again';
    }
  }

  search.addEventListener('input', () => {
    clearTimeout(timer);
    timer = setTimeout(() => load(true), 250);
  });
  more.addEventListener('click', () => { more.textContent = 'Show more members ↓'; load(); });
  dialog.querySelector('.fc-community__dialog-close').addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => {
    const url = new URL(location.href);
    url.searchParams.delete('member');
    history.replaceState(null, '', url);
  });
  load(true);
 };
 boot();
 document.addEventListener('shopify:section:load',boot);
})();
